import { ParsedUrlQuery } from 'querystring';

type IsOptimizelyFeatureEnabledProps = {
    feature: string;
    query: ParsedUrlQuery;
};

type IsOptimizelyFeatureEnabled = ({
    feature,
    query
}: IsOptimizelyFeatureEnabledProps) => Promise<boolean>;

const isOptimizelyFeatureEnabled: IsOptimizelyFeatureEnabled = async ({
    feature,
    query
}) => {
    const { loadOptimizely, isFeatureEnabled } = await import(
        '../../../shared/optimizely/deprecated/deprecated-optimizely'
    );

    const optimizely = await loadOptimizely();

    return isFeatureEnabled(optimizely, feature, query);
};

export { isOptimizelyFeatureEnabled };
